'use client'

import React, { createContext, useContext, useState } from 'react'

export type AppContext = {
  isMobile: boolean
  distinctId: string
  setDistinctId: React.Dispatch<React.SetStateAction<string>>
}

const defaultContext = {
  isMobile: true,
  distinctId: '',
  setDistinctId: () => {}
}

export const AppContext = createContext<AppContext>(defaultContext)

export default function AppContextProvider({ children, isMobile }: { children: React.ReactNode, isMobile: boolean }) {
  const [distinctId, setDistinctId] = useState('')

  return (
    <AppContext.Provider value={{ isMobile, distinctId, setDistinctId }}>
      {children}
    </AppContext.Provider>
  )
}

export function useAppContext() {
  return useContext(AppContext)
}
